import { random } from "lodash";
import { FC, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { CardStyled } from "../../components/Card.styled";
import Product from "../../dtos/Product.dto";
import ProductCharacteristics from "../../dtos/ProductCharacteristics.dto";
import Spacer from "../../styled/Spacer";
import Text from "../../styled/Text";
import { decode } from "../../utils/decode";
import { BreadcrumbItem } from "../Breadcrumb";
import CityLawyerPopUp from "../CityLawyerLeadPopUp";
import CorneredBox from "../CorneredBox";
import HeadingText1 from "../HeadingText1";
import {
  ProductBButton,
  ProductBDivImage,
} from "../LegalConsultationProductB.styled";
import useResponsiveDevice from "../useResponsiveDevice";
import LeadCityLawyerForm from "./LeadCityLawyerForm";

interface Props {
  product: Product;
  city: string;
  concernedArea?: string;
  city_data: any;
  lawyersProfile: any;
  finalConcernedAreaData: any;
}

const FindAllLawyersHeader: FC<Props> = ({
  product,
  city,
  concernedArea,
  city_data,
  lawyersProfile,
  finalConcernedAreaData,
}) => {
  const { isMobile } = useResponsiveDevice();
  const [show, setShow] = useState(false);
  const handleClosePop = () => {
    setShow(false);
  };
  const breadcrumbItems: BreadcrumbItem[] = [
    {
      label: "",
      link: "/",
    },
    {
      label: "",
      link: null,
    },
  ];
  const banner_title = city_data?.cities?.banner?.title?.replace(
    /<Akhnur>/g,
    city
  );
  const banner_content = city_data?.cities?.banner?.content?.replace(
    /<Akhnur>/g,
    city
  );

  const banner_title_concern_area =
    finalConcernedAreaData?.cities?.banner?.title?.replace(/<Akhnur>/g, city);
  const banner_content_concern_area =
    finalConcernedAreaData?.cities?.banner?.content?.replace(/<Akhnur>/g, city);

  return (
    <CorneredBox
      marginTop="-25px"
      paddingTop="30px"
      zIndex={16}
      position="relative"
    >
      <ProductBDivImage
        className="row ml-0 mr-0"
        style={{ marginTop: -30, paddingBottom: 50 }}
      >
        <div>
          {/* <ProductBVideo autoPlay muted loop>
            <source
              src="/city-lawyers/videos/legal-consultation.mp4"
              type="video/mp4"
            />
          </ProductBVideo> */}
          {/* <ProductBLayerDark className="col-12 m-0 p-0" /> */}
          {/* <ProductBLayer className="col-12 m-0 p-0" /> */}
          {/* <ProductBLayerDark2 className="col-12 m-0 p-0" /> */}
        </div>

        <Container className="pt-5">
          {/* <Breadcrumb items={breadcrumbItems} /> */}
          <Row>
            <Col xs={12} md={7}>
              <HeadingText1
                fontSize="xxxl"
                weight="bold"
                color="white"
                fontFamily="montserrat"
              >
                {banner_title_concern_area != "" &&
                banner_title_concern_area != undefined
                  ? banner_title_concern_area
                  : banner_title
                  ? banner_title
                  : concernedArea !== "" && city !== ""
                  ? `Consult ${concernedArea} Lawyers in ${city}`
                  : concernedArea == "" && city !== ""
                  ? `Connect with Expert Lawyers in ${
                      city !== "" ? city : "your city"
                    }`
                  : "Connect with Expert Lawyers in your city"}
                {/* {!concernedArea && banner_title ? banner_title :
                  concernedArea !== '' && city !== '' 
                  ? `Consult ${concernedArea} Lawyers in ${city}`
                  : concernedArea == '' && city !== '' ? `Connect with Expert Lawyers in ${city !== '' ? city : 'your city'}`
                  : "Connect with Expert Lawyers in your city"
                } */}
              </HeadingText1>
              <Spacer direction="vertical" size={10} />
              <div
                className={`d-flex justify-content-lg-start ${
                  isMobile ? "flex-column" : "align-items-center"
                }`}
              >
                <div
                  className="d-flex align-items-center"
                  data-clarity-unmask="True"
                >
                  <img
                    data-src={
                      "https://i.ibb.co/fNhX2XC/wifi-tethering-24pxonline.png"
                    }
                    alt={"copy"}
                    width={20}
                    className="lozad mr-2"
                  />
                  <Text
                    fontSize="md"
                    weight="bold"
                    color="white"
                    style={{
                      margin: "unset",
                    }}
                    data-clarity-unmask="True"
                  >
                    {random(90, 120)} Lawyers online
                  </Text>
                </div>
                <Spacer
                  size={isMobile ? 10 : 20}
                  direction={isMobile ? "vertical" : "horizontal"}
                />
                <div className="d-flex align-items-center">
                  <img
                    data-src={"https://i.ibb.co/g9ZB0Rv/call-24pxcalls.png"}
                    alt={"stars"}
                    width={20}
                    className="lozad mr-2"
                  />
                  <Text
                    fontSize="md"
                    weight="bold"
                    color="white"
                    style={{
                      margin: "unset",
                    }}
                  >
                    {random(40, 80)} Calls currently going on
                  </Text>
                </div>
              </div>

              <Spacer direction="vertical" size={14} />
              <Text
                as="div"
                dangerouslySetInnerHTML={{
                  __html:
                    banner_content_concern_area != "" &&
                    banner_content_concern_area != undefined
                      ? banner_content_concern_area
                      : banner_content
                      ? banner_content
                      : product?.description,
                }}
                fontSize="mdl"
                weight="normal"
                color="white"
              ></Text>
              <Spacer direction="vertical" size={10} />

              <ProductBButton
                onClick={() => {
                  setShow(true);
                  // const newPath = `${Site_url}legal-consultation`;
                  // window.location.href = newPath;

                  // router.push("/legal-consultation");
                }}
              >
                <a
                  // href={city_data?.cities?.banner?.button?.link ? city_data?.cities?.banner?.button?.link : 'https://www.ezylegal.in/legal-consultation'}
                  style={{ color: "white" }}
                >
                  {finalConcernedAreaData?.cities?.banner?.button?.buttonText
                    ? finalConcernedAreaData?.cities?.banner?.button?.buttonText
                    : city_data?.cities?.banner?.button?.buttonText
                    ? city_data?.cities?.banner?.button?.buttonText
                    : "Consult Lawyer"}
                  <img
                    width={24}
                    src="/city-lawyers/icons/arrow-forward.svg"
                    alt="arrow"
                    // className="lazyload ml-2"
                    className="lozad ml-2"
                    data-src={"/icons/arrow-forward.svg"}
                  />
                </a>
              </ProductBButton>

              <hr
                style={{
                  marginTop: "2.5rem",
                  marginBottom: "2.5rem",
                  border: 0,
                  borderTop: "1px solid rgba(255, 255, 255, 0.1)",
                }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  gap: "1.5rem",
                }}
              >
                {product.product_addition?.productCharacteristics?.map(
                  (
                    productCharacteristic: ProductCharacteristics,
                    index: number
                  ) => {
                    return (
                      <div
                        className={`d-md-flex align-items-center ${
                          isMobile ? "mb-3 text-center" : ""
                        }`}
                        key={index}
                      >
                        <img
                          data-src={productCharacteristic.icon?.sourceUrl}
                          // alt={productCharacteristic.icon?.title}
                          alt={productCharacteristic?.alttext}
                          width={40}
                          style={{
                            width: 40,
                            height: 40,
                            objectFit: "contain",
                            marginRight: ".625rem",
                            filter:
                              "invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)",
                          }}
                          className="lozad"
                        />
                        {isMobile && <Spacer direction="vertical" size={10} />}
                        <Text
                          inline
                          color="white"
                          className="mb-0"
                          fontSize={isMobile ? "sm" : "base"}
                          weight="semibold"
                        >
                          {process.browser
                            ? decode(productCharacteristic.label)
                            : productCharacteristic.label}
                        </Text>
                      </div>
                    );
                  }
                )}
              </div>
            </Col>
            <Col xs={12} md={5}>
              <Row
                style={{
                  position: "sticky",
                  top: 20,
                  maxHeight: isMobile ? "unset" : "95vh",
                  overflowY: "auto",
                }}
                className="mb-3"
              >
                <Col>
                  <CardStyled className="shadow-sm">
                    <CardStyled.Header className="d-flex align-items-center justify-content-center">
                      <Text
                        className="mb-0 underline"
                        fontSize="lg"
                        weight="semibold"
                      >
                        Ask Lawyer
                      </Text>
                    </CardStyled.Header>
                    <CardStyled.Body>
                      <LeadCityLawyerForm />
                    </CardStyled.Body>
                  </CardStyled>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </ProductBDivImage>
      <CityLawyerPopUp
        show={show}
        onHide={handleClosePop}
        size="lg"
        type={"author"}
      />
    </CorneredBox>
  );
};

export default FindAllLawyersHeader;
